import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientWellnessPlan = (state, patientId) =>
  allModelsSelector(state, 'PatientWellnessPlan').find((wP) => wP.patientId === patientId);
